import { FileFinepModel } from "../../../Models/FileFinepModel";
import ExistedInputForm from "../ExistedInputForm";
import UploadInputForm from "../UploadInputForm";


const inputsByDocType = [
    {
        docType: 0,
        inputs: 3
    },
    {
        docType: 1,
        inputs: 3
    },
    {
        docType: 2,
        inputs: 1
    },
    {
        docType: 3,
        inputs: 1
    },
    {
        docType: 4,
        inputs: 1
    },
    {
        docType: 5,
        inputs: 1
    },
]

interface UploadInputByDocTypeProps {
    files: FileFinepModel[],
    docType: 0 | 1 | 2 | 3 | 4 | 5,
    HandleCheckChange?: (id: string, value: boolean) => void,
}

const UploadInputByDocType = ({ files, docType, HandleCheckChange }: UploadInputByDocTypeProps) => {

    const inputsByType = inputsByDocType.find(x => x.docType === docType);

    if (!inputsByType)
        return null;

    const filesWithType = files.filter(x => x.docType == docType);

    const existedFilesCount = inputsByType.inputs - filesWithType.length;

    const existedFilesComponent = Array.from({ length: filesWithType.length }, (_, index) => (
        <ExistedInputForm
            key={index}
            fileFinep={filesWithType[index]}
            identification={`${docType}-${index}`}
            HandleCheckChange={HandleCheckChange}
        />
    ));

    const notExistedFilesComponent = Array.from({ length: existedFilesCount }, (_, index) => (
        <UploadInputForm
            key={index * index}
            docType={docType}
            HandleCheckChange={HandleCheckChange}
            identification={`${docType}-${index}`}
        />
    ));

    const allComponents = [...existedFilesComponent, notExistedFilesComponent];

    return (
        <>
            {allComponents}
        </>
    )

}

export default UploadInputByDocType;